/**
 * Base Logger
 *
 * Universal logger usable from any execution context (server boot,
 * preload scripts, Payload CLI, browser SSR fallback). Uses
 * ConsoleTransport with JSON output for Datadog consumption.
 * Consumers attach module context via `getLogger({ module })`.
 *
 * @see https://loglayer.dev/transports/console.html#structured-logging
 */
import { ConsoleTransport, LogLayer } from 'loglayer'

import type { Logger } from './types'
import { LoggerWrapper } from './wrapper'

export const baseLogger: Logger = new LoggerWrapper(
    new LogLayer({
        transport: new ConsoleTransport({
            logger: console,
            messageField: 'message',
            levelField: 'level',
            levelFn: (level) => level.toUpperCase(),
            dateField: 'time',
            stringify: true,
        }),
    }),
)
